import { useEffect, useState, type FormEvent } from 'react';
import { Button, Field, FormSection, Input } from '../../ui';
import { useAuth } from '../../contexts/AuthContext';

export function ProfileTab() {
  const { user, updateProfile } = useAuth();
  const [name, setName] = useState(user?.name ?? '');
  const [error, setError] = useState<string | null>(null);
  const [savedAt, setSavedAt] = useState<number | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setName(user?.name ?? '');
  }, [user?.name]);

  const trimmed = name.trim();
  const dirty = trimmed.length > 0 && trimmed !== (user?.name ?? '');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!dirty || submitting) return;
    setError(null);
    setSubmitting(true);
    try {
      await updateProfile({ name: trimmed });
      setSavedAt(Date.now());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to update profile');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="profile-tab" noValidate>
      <FormSection
        title="Profile"
        description="The name displayed across the dashboard. Email is set when your account is created and can't be changed here."
      >
        <Field label="Name" required error={error ?? undefined}>
          <Input
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Your name"
            autoComplete="name"
            maxLength={120}
          />
        </Field>

        <Field label="Email">
          <Input value={user?.email ?? ''} readOnly disabled />
        </Field>

        <div className="profile-tab__actions">
          <Button type="submit" disabled={!dirty || submitting} loading={submitting}>
            Save changes
          </Button>
          {savedAt && !dirty && !error ? (
            <span className="profile-tab__saved" role="status">
              Saved
            </span>
          ) : null}
        </div>
      </FormSection>
    </form>
  );
}
